 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"settings": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"settings": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0044fcbf":"e595f7f2","chunk-06c6a1b8":"9a3e07d3","chunk-08bfb246":"38b9b810","chunk-0b525fc9":"fb7e8cf4","chunk-2d0ab062":"54e8c08b","chunk-2d0aeaf6":"8702e445","chunk-2d0b1d56":"f6ed9d9b","chunk-2d0b2899":"273b0ae1","chunk-2d0b2e6a":"0bf805a7","chunk-2d0b59c2":"2c6c501a","chunk-2d0ba11e":"a54fab4d","chunk-2d0ba48f":"1150ca48","chunk-2d0bacc9":"e41d1702","chunk-2d0c7ad3":"e63461db","chunk-2d0c7f15":"5d31d896","chunk-2d0cb783":"f7da48b9","chunk-2d0cba67":"bdeacc55","chunk-2d0d0b96":"536cf358","chunk-2d0d4067":"dc7eed1e","chunk-2d0d724a":"bb89f024","chunk-2d0db085":"574d5845","chunk-2d0db2b2":"a17ee452","chunk-2d0ddf81":"ac86f59f","chunk-2d0e88a1":"33db959b","chunk-2d0f0c12":"ac66cb72","chunk-2d0f0f43":"cf58a5ec","chunk-2d20fee3":"274f2bac","chunk-2d213ca8":"0ad3d231","chunk-2d2169f4":"538916c8","chunk-2d21d0fd":"d0ee5097","chunk-2d21d821":"74e2409b","chunk-2d21da35":"b7c8564e","chunk-2d224c28":"eadd3470","chunk-2d22d366":"3e87c8db","chunk-2d230c8e":"89004a95","chunk-2fc308e7":"f35130f1","chunk-413d497f":"d5508397","chunk-45be5533":"1054d645","chunk-523599ca":"0b14bf1d","chunk-531523ce":"19be6986","chunk-68a76640":"ce8361a8","chunk-743f996d":"bcc76ae0","chunk-774b3886":"25d5fd55","chunk-9b3a03f2":"5a2ffb70","chunk-a4b49a08":"c5660c5a","chunk-cffcc456":"0c11f1d1","chunk-deeef6ae":"d5a7e733","chunk-def04b98":"dbb0bd58","chunk-def165fa":"b6496945","chunk-df195bd2":"26e60052","chunk-f1663fa0":"d577ad8d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0044fcbf":1,"chunk-0b525fc9":1,"chunk-2fc308e7":1,"chunk-413d497f":1,"chunk-523599ca":1,"chunk-531523ce":1,"chunk-68a76640":1,"chunk-a4b49a08":1,"chunk-cffcc456":1,"chunk-f1663fa0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0044fcbf":"da63465e","chunk-06c6a1b8":"31d6cfe0","chunk-08bfb246":"31d6cfe0","chunk-0b525fc9":"5efc80c5","chunk-2d0ab062":"31d6cfe0","chunk-2d0aeaf6":"31d6cfe0","chunk-2d0b1d56":"31d6cfe0","chunk-2d0b2899":"31d6cfe0","chunk-2d0b2e6a":"31d6cfe0","chunk-2d0b59c2":"31d6cfe0","chunk-2d0ba11e":"31d6cfe0","chunk-2d0ba48f":"31d6cfe0","chunk-2d0bacc9":"31d6cfe0","chunk-2d0c7ad3":"31d6cfe0","chunk-2d0c7f15":"31d6cfe0","chunk-2d0cb783":"31d6cfe0","chunk-2d0cba67":"31d6cfe0","chunk-2d0d0b96":"31d6cfe0","chunk-2d0d4067":"31d6cfe0","chunk-2d0d724a":"31d6cfe0","chunk-2d0db085":"31d6cfe0","chunk-2d0db2b2":"31d6cfe0","chunk-2d0ddf81":"31d6cfe0","chunk-2d0e88a1":"31d6cfe0","chunk-2d0f0c12":"31d6cfe0","chunk-2d0f0f43":"31d6cfe0","chunk-2d20fee3":"31d6cfe0","chunk-2d213ca8":"31d6cfe0","chunk-2d2169f4":"31d6cfe0","chunk-2d21d0fd":"31d6cfe0","chunk-2d21d821":"31d6cfe0","chunk-2d21da35":"31d6cfe0","chunk-2d224c28":"31d6cfe0","chunk-2d22d366":"31d6cfe0","chunk-2d230c8e":"31d6cfe0","chunk-2fc308e7":"562aaa16","chunk-413d497f":"327f3863","chunk-45be5533":"31d6cfe0","chunk-523599ca":"d73f248d","chunk-531523ce":"3c0fe4f5","chunk-68a76640":"1ad88db1","chunk-743f996d":"31d6cfe0","chunk-774b3886":"31d6cfe0","chunk-9b3a03f2":"31d6cfe0","chunk-a4b49a08":"4a37cf07","chunk-cffcc456":"3188bf47","chunk-deeef6ae":"31d6cfe0","chunk-def04b98":"31d6cfe0","chunk-def165fa":"31d6cfe0","chunk-df195bd2":"31d6cfe0","chunk-f1663fa0":"4359098c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/public/bundles_vue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
